import { useTranslation } from 'react-i18next';
import { NavPills, NavItem } from 'app/components';
import { Outlet } from '@tanstack/react-router';
import { useDocumentParams } from 'app/router/params';
import { TagContextProvider } from 'app/state/contexts/TagContext';
import { TagDetailsModalProvider } from './TagDetailsModalContext';

export const TaggingSettings = () => {
  const { t } = useTranslation('tag');

  const { documentId } = useDocumentParams();

  const items: NavItem[] = [
    { text: t('tags.label'), to: '/documents/$documentId/tagging', params: { documentId } },
    { text: t('mandatory.tags'), to: '/documents/$documentId/tagging/mandatory', params: { documentId } },
    { text: t('taxonomy.plural'), to: '/documents/$documentId/tagging/taxonomies', params: { documentId } },
    { text: t('categories.label'), to: '/documents/$documentId/tagging/categories', params: { documentId } },
    { text: t('extensions.label'), to: '/documents/$documentId/tagging/extensions', params: { documentId } },
    { text: t('treeOverview.label'), to: '/documents/$documentId/tagging/tree', params: { documentId } },
    { text: t('export.label'), to: '/documents/$documentId/tagging/export', params: { documentId } },
  ];

  return (
    <TagContextProvider>
      {/* The details modal is provided rather than prop-drilled: the sub-views are routes now. */}
      <TagDetailsModalProvider>
        <div className="mt-5">
          <NavPills items={items} className="d-inline-flex" />
        </div>

        <Outlet />
      </TagDetailsModalProvider>
    </TagContextProvider>
  );
};
